import { createTheme } from "@mui/material/styles";

const muiDefaultTheme = createTheme();
export default muiDefaultTheme;
